import React from 'react';
import { X } from 'lucide-react';
import type { Toast } from '@/types/components/common/toast';
import { TOAST_ICONS, TOAST_VARIANTS } from '@/types/components/common/toast';

interface ToastItemProps extends Toast {
    onRemove: (id: string) => void;
}

export const ToastItem: React.FC<ToastItemProps> = ({
                                                        id,
                                                        type,
                                                        title,
                                                        message,
                                                        onRemove
                                                    }) => {
    const Icon = TOAST_ICONS[type];
    const variant = TOAST_VARIANTS[type];

    return (
        <div
            className={`
                flex items-start gap-3 w-full max-w-sm rounded-lg border p-4
                shadow-lg animate-slide-in
                ${variant.base}
            `}
            role="alert"
        >
            <Icon className={`h-6 w-6 mt-0.5 flex-shrink-0 ${variant.icon}`} />

            <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${variant.title}`}>
                    {title}
                </p>
                {message && (
                    <p className={`mt-1 text-sm ${variant.message}`}>
                        {message}
                    </p>
                )}
            </div>

            <button
                onClick={() => onRemove(id)}
                className={`flex-shrink-0 hover:opacity-70 transition-opacity ${variant.title}`}
                aria-label="Close notification"
            >
                <X className="h-5 w-5" />
                <span className="sr-only">Close</span>
            </button>
        </div>
    );
};